import {fromSnakeCaseToCamelCaseReviver} from '../../common/json/jsonUtils';
import {
  generateSeoInfo,
  setGlobalUtagDataIfOnClient,
  setGlobalDataLayerIfOnClient,
  shouldRenderSeoContent,
} from '../../modules/seo/seoUtils';

function generateDefaultInitialSeoState() {
  return {
    seoInfo: null,
    pageDeepLink: null,
    renderSeoContent: true
  };
}


function seoReducer(state = generateDefaultInitialSeoState(), action) {
  let newState;
  const seoInfo = generateSeoInfo(action.payload);
  if (seoInfo?.utagData) {
    seoInfo.utagData.page_deep_link = state.pageDeepLink;
  }
  const utagData = seoInfo?.utagData;
  switch (action.type) {
    case 'SET_DYNAMIC_VIEW_SEO_INFO':
    case 'SET_BRAND_SEO_INFO':
      newState = {
        ...state,
        seoInfo,
        utagData: utagData ? JSON.parse(JSON.stringify(utagData), fromSnakeCaseToCamelCaseReviver) : {},
      };

      setGlobalUtagDataIfOnClient(seoInfo?.utagData);
      setGlobalDataLayerIfOnClient(seoInfo?.utagData);

      break;
    case 'SET_MERCHANT_SEO_INFO':
      newState = {
        ...state,
        seoInfo,
        moriaSeoState: action.payload.moriaSeoState,
        utagData: utagData ? JSON.parse(JSON.stringify(utagData), fromSnakeCaseToCamelCaseReviver) : {},
      };

      setGlobalUtagDataIfOnClient(seoInfo?.utagData);
      setGlobalDataLayerIfOnClient(seoInfo?.utagData);

      break;

    case 'GET_CATEGORY_PRODUCTS':
    case 'GET_SEARCH_PRODUCTS':
    case 'GET_TAG_PRODUCTS':
    case 'GET_BRAND_PRODUCTS': {
      newState = {
        ...state,
        renderSeoContent: shouldRenderSeoContent({ page: action.payload.params.sayfa })
      };
      break;
    }

    case 'GET_CATEGORY_INFORMATION_FULFILLED':
    case 'GET_SEO_INFORMATION_CATEGORY_FULFILLED':
    case 'GET_CATEGORY_PRODUCTS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }
      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_SEARCH_PRODUCTS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_TAG_PRODUCTS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_BRAND_PRODUCTS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_CAMPAIGNS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_AUTHORS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_BRANDS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_MERCHANTS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_PRODUCT_FULFILLED':
    case 'GET_BASIC_PRODUCT_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_SEO_INFO_FULFILLED': {
      const seoInfo = generateSeoInfo(action.payload.response.data.data);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      const utagData = seoInfo?.utagData;

      newState = {
        ...state,
        seoInfo,
        utagData: utagData ? JSON.parse(JSON.stringify(utagData || {}), fromSnakeCaseToCamelCaseReviver) : {},
      };

      setGlobalUtagDataIfOnClient(seoInfo.utagData);
      setGlobalDataLayerIfOnClient(seoInfo.utagData);

      break;
    }

    case 'GET_GENERIC_SEO_INFO': {
      newState = {
        ...state,
        renderSeoContent: shouldRenderSeoContent({ page: action.payload.body.currentPage })
      }

      break;
    }

    case 'GET_GENERIC_SEO_INFO_FULFILLED': {
      const seoInfo = generateSeoInfo(action.payload.response.data.data);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      const utagData = seoInfo?.utagData;

      newState = {
        ...state,
        seoInfo,
        utagData: utagData ? JSON.parse(JSON.stringify(utagData), fromSnakeCaseToCamelCaseReviver) : {},
      };

      setGlobalUtagDataIfOnClient(seoInfo?.utagData);
      setGlobalDataLayerIfOnClient(seoInfo?.utagData);

      break;
    }

    case 'SET_SEO_INFO': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);
      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'UPDATE_SEO_INFO': {
      newState = {
        ...state,
        seoInfo: {
          ...state.seoInfo,
          ...action?.payload?.response
        }
      };

      break;
    }

    case 'SET_NEXT_SEO_INFO': {
      const seoInfo = generateSeoInfo({
        ...action?.payload?.response?.data?.data?.seoInformation,
        h2: state.seoInfo.h2,
        searchKeywordArray: state.seoInfo.searchKeywordArray,
        seoParagraph: state.seoInfo.seoParagraph,
        questions: state.seoInfo.questions,
      });

      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'GET_DEEP_LINK_FULFILLED': {
      const {
        seoInfo,
      } = state;

      const pageDeepLink = action.payload.response.data?.data?.deepLink;
      newState = {
        ...state,
        pageDeepLink,
        seoInfo: {
          ...seoInfo,
          utagData: {
            ...seoInfo?.utagData,
            page_deep_link: pageDeepLink,
          },
        },
      };

      break;
    }

    case 'GET_MORIA_TAG_PAGE_COMPONENTS_FULFILLED': {
      const seoInfo = generateSeoInfo(action?.payload?.response?.data?.data?.seoInformation);

      if (seoInfo?.utagData) {
        seoInfo.utagData.page_deep_link = state.pageDeepLink;
      }

      newState = {
        ...state,
        seoInfo,
      };

      break;
    }

    case 'LEAVE_DYNAMIC_PAGE_ROUTE': {
      newState = {
        ...state,
        ...generateDefaultInitialSeoState(),
      };

      break;
    }

    default:
      newState = state;
  }

  if (action.isLeaveRouteAction) {
    newState = {
      ...newState,
      seoInfo: null,
    };
  }

  return newState;
}

export default seoReducer;
export {
  generateDefaultInitialSeoState,
};
